export default {
  MULTIPLE_CHOICE: {
    DEFAULT_OPTIONS: [
      'ja', 'nee'
    ],
    OFFLINE_MESSAGE:
      'Sorry ik heb momenteel geen internet. Ik kan je antwoord hierdoor niet verwerken.'
  }
}